// src/GlobalContext.jsx
import React, { createContext, useState, useEffect } from "react";

// إنشاء الكونتكست
export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  // كل الـ state الخاصة بالإعدادات
  const [heroImg, setHeroImg] = useState("");
  const [appstoreImg, setAppstoreImg] = useState("");
  const [googleplayImg, setGoogleplayImg] = useState("");
  const [heroTitle, setHeroTitle] = useState("عنوان تجريبي");
  const [heroSubtitle, setHeroSubtitle] = useState("وصف تجريبي للموقع");
  const [logo, setLogo] = useState("");
  const [mainImg, setMainImg] = useState("");
  const [whatsappImgs, setWhatsappImgs] = useState([]);
  const [valuesImg, setValuesImg] = useState("");
  const [portfolioImgs, setPortfolioImgs] = useState([]);

  // ✅ عند أول تحميل نحاول نجيب الداتا من localStorage
  useEffect(() => {
    const saved = localStorage.getItem("appSettings");
      console.log("🟢 Loaded from localStorage:", saved); 
    if (saved) {
      const parsed = JSON.parse(saved);
      setHeroImg(parsed.hero_img || "");
      setAppstoreImg(parsed.appstore_img || "");
      setGoogleplayImg(parsed.googleplay_img || "");
      setHeroTitle(parsed.hero_title || "عنوان تجريبي");
      setHeroSubtitle(parsed.hero_subtitle || "وصف تجريبي للموقع");
      setLogo(parsed.logo || "");
      setMainImg(parsed.main_img || "");
      setWhatsappImgs(parsed.whatsapp_imgs || []);
      setValuesImg(parsed.values_img || "");
      setPortfolioImgs(parsed.portfolio_imgs || []);
    }
  }, []);

  // ✅ أي تعديل نحفظه في localStorage
  useEffect(() => {
    const payload = {
      hero_img: heroImg,
      appstore_img: appstoreImg,
      googleplay_img: googleplayImg,
      hero_title: heroTitle,
      hero_subtitle: heroSubtitle,
      logo,
      main_img: mainImg,
      whatsapp_imgs: whatsappImgs,
      values_img: valuesImg,
      portfolio_imgs: portfolioImgs,
    };

    // 🧩 أضفنا السطر ده عشان نعرف القيم اللي بتتحفظ فعلاً
    console.log("🟡 Saving payload:", payload);

    localStorage.setItem("appSettings", JSON.stringify(payload));
  }, [
    heroImg,
    appstoreImg,
    googleplayImg,
    heroTitle,
    heroSubtitle,
    logo,
    mainImg,
    whatsappImgs,
    valuesImg,
    portfolioImgs,
  ]);

  return (
    <GlobalContext.Provider
      value={{
        heroImg,
        setHeroImg,
        appstoreImg,
        setAppstoreImg,
        googleplayImg,
        setGoogleplayImg,
        heroTitle,
        setHeroTitle,
        heroSubtitle,
        setHeroSubtitle,
        logo,
        setLogo,
        mainImg,
        setMainImg,
        whatsappImgs,
        setWhatsappImgs,
        valuesImg,
        setValuesImg,
        portfolioImgs,
        setPortfolioImgs,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
